// 通用方法
/**
 * 通用深拷贝
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
export function deepClone (source) {
  if (!source && typeof source !== 'object') {
    throw new Error('error arguments', 'deepClone')
  }
  const targetObj = source.constructor === Array ? [] : {}
  Object.keys(source).forEach(keys => {
    if (source[keys] && typeof source[keys] === 'object') {
      targetObj[keys] = deepClone(source[keys])
    } else {
      targetObj[keys] = source[keys]
    }
  })
  return targetObj
}

/**
 *
 * 生成随机的guid
 * @export
 * @returns {String}
 */
export function guid () {
  function S4 () {
    return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1)
  }
  return (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4())
}

/**
 *
 *  去除-的guid 作为随机id 限定可限定位数
 * @param {*} len id长度
 * @return {*}
 */
export function uuid (len) {
  const length = len ? len > 32 ? 32 : len : 16
  const id = guid()
  return id.replace(/-/g, '').slice(0, length)
}

/**
 *
 * 根据时间返回当月的总天数
 * @export
 * @param {Date} date
 * @returns {Number}
 */
export function getMonthLength (date) {
  const d = new Date(date)
  // 将日期设置为下月一号
  d.setMonth(d.getMonth() + 1)
  d.setDate('1')
  // 获取本月最后一天
  d.setDate(d.getDate() - 1)
  return d.getDate()
}

/**
 *
 * 移除数组的某个元素
 * @export
 * @param {*} arr
 * @param {*} el
 */
export function remove (arr, el) {
  const index = arr.indexOf(el)
  if (index > -1) {
    arr.splice(index, 1)
  }
}

/**
 *
 * 转换数组数据
 * 将数据相同的tagName组合到一起
 * @export
 * @param {*} resData
 * @return {*}
 */
export function foldArr (resData, tagName) {
  const tempArr = []
  const data = []
  for (let i = 0; i < resData.length; i++) {
    if (tempArr.indexOf(resData[i][tagName]) === -1) {
      const o = {}
      o[tagName] = resData[i][tagName]
      o.data = [resData[i]]
      data.push(o)
      tempArr.push(resData[i][tagName])
    } else {
      for (let j = 0; j < data.length; j++) {
        if (data[j][tagName] === resData[i][tagName]) {
          data[j].data.push(resData[i])
          break
        }
      }
    }
  }
  return data
}

/**
 *
 * foldArr数组重组
 * @export
 * @param {*} resData
 * @param {*} tagName
 */
export function regroupArr (resData, tagName, pick) {
  const arr = foldArr(resData, tagName)
  const data = []
  for (let i = 0; i < arr.length; i++) {
    const o = {}
    o[tagName] = arr[i][tagName]
    for (let j = 1; j < arr[i].data.length + 1; j++) {
      o[pick + j] = arr[i].data[j - 1][pick]
    }
    data.push(o)
  }
  return data
}
/**
 *
 * 图表x轴数据整合
 * @export
 * @param {*} arr
 * @return {*}
 */
export function combineData (beforeData, propertyName) {
  const tempArr = []
  const afterData = []
  beforeData.forEach(item => {
    if (tempArr.indexOf(item[propertyName]) === -1) {
      afterData.push(item)
      tempArr.push(item[propertyName])
    } else {
      afterData.forEach(v => {
        if (v[propertyName] === item[propertyName]) {
          delete item[propertyName]
          Object.assign(v, item)
        }
      })
    }
  })
  return afterData
}
/**
 *
 * 去除两个对象中相等的属性值
 * @export
 * @param {*} oldObject 旧的对象
 * @param {*} newObject 改变后的对象
 */
export function removeEqParams (oldObject, newObject) {
  Object.keys(newObject).forEach(key => {
    // console.log(newObject[key], oldObject[key])
    if (newObject[key] === oldObject[key]) {
      delete newObject[key]
    }
  })
  return newObject
}

/**
 *
 * 时间格式化
 * @export
 * @param { Date } date
 * @param { String } fmt
 * @return { String }
 */
export function parseTime (date, fmt) {
  if (!date) return '--'
  var d = new Date(date)
  var o = {
    'M+': d.getMonth() + 1, // 月份
    'd+': d.getDate(), // 日
    'h+': d.getHours(), // 小时
    'm+': d.getMinutes(), // 分
    's+': d.getSeconds(), // 秒
    'q+': Math.floor((d.getMonth() + 3) / 3), // 季度
    S: d.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (d.getFullYear() + '').substr(4 - RegExp.$1.length))
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) { fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length))) }
  }
  return fmt
}

/**
 * @param {Object} object//取到的值
 */
export function formPosition (object) {
  for (const i in object) {
    let dom = this.$refs[i]
    if (Object.prototype.toString.call(dom) !== '[object Object]') { // 这里是针对遍历的情况（多个输入框），取值为数组
      dom = dom[0]
    }
    // 第一种方法（包含动画效果）
    dom.$el.scrollIntoView({ // 滚动到指定节点
      block: 'center', // 值有start,center,end，nearest，当前显示在视图区域中间
      behavior: 'smooth'// 值有auto、instant,smooth，缓动动画（当前是慢速的）
    })
    break // 因为我们只需要检测一项,所以就可以跳出循环了
  }
}
export function week (date) {
  var week = ['日', '一', '二', '三', '四', '五', '六']
  if (typeof date === 'number') return week[date]
  var d = new Date(date)
  return week[d.getDay()]
}

